module.exports = __webpack_public_path__ + "img/fishHeadBg.5443aae9.png";